__turbopack_context__.v({
  "picture": "Picture-module-scss-module__Gq-XOG__picture",
  "picture--responsive": "Picture-module-scss-module__Gq-XOG__picture--responsive",
});
